var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"salesforce-auth"}},[_c('button',{attrs:{"id":"salesforce-login-button"},on:{"click":_vm.loginHandler}},[_vm._v("\n    Login to Seer\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }